//TODO: Add any type

import { normalizeMembershipTier } from "src/utils/helpers";

export const selectUserToken = (state: any) => state.user.token;
export const selectUserCountryCode = (state: any) => state.user.countryCode;
export const selectUserData = (state: any) => state.user.userData;
export const selectUserError = (state: any) => state.user.error;
export const selectUserLoading = (state: any) => state.user.loading;
export const selectRegisterUserLoading = (state: any) => state.user.loading;
export const selectRegisterUserError = (state: any) => state.user.error;

export const selectAddressData = (state: any) => state.user.addressData;
export const selectAddressLoading = (state: any) => state.user.loading;
export const selectAddressError = (state: any) => state.user.error;
export const selectCreditPoints = (state: any) => state.user.creditPoints;
export const selectCreditHistory = (state: any) => state.user.creditHistory;
export const selectCreditHistoryPagination = (state: any) =>
  state.user.creditHistoryPagination;
export const selectCreditHistoryLoading = (state: any) =>
  state.user.creditHistoryLoading;
export const selectCreditHistoryError = (state: any) =>
  state.user.creditHistoryError;
export const selectUserId = (state: any) => state.user.userData?.id;
export const selectMembershipTier = (state: any) =>
  normalizeMembershipTier(state.user.userData?.membershipTier);
